import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import '@/style/index.less'
import 'font-awesome/less/font-awesome.less'

const app = createApp(App);
app.config.globalProperties.$hasPermission = function (code) {
  let userInfo = store.state.userInfo;
  let role = userInfo.role;
  if (role === "62d2c9f7f02777067cbb49dc" || role === "62d425328577dec6c227321b") {
     return true;
  }

  let permissionCodes = userInfo.permissionCodes;
  if (!permissionCodes) {
     return false;
  }

  let arr = permissionCodes.split(";");
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === code) {
      return true;
    }
  }
  return false;
};

app.use(router).use(store).use(Antd).mount('#app')
